import { noop } from "lodash";
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useEffect, useState } from "react";

import { IExpenditureInHandlerProduction } from "pages/Handler/ui/ProHandler/components/Body/components/Expenditures/types";

import { useBuildingMatchingProductInfo } from "./useBuildingMatchingProductInfo";

const BuildingMatchingContext = createContext<BuildingMatchingContextType>({
  relationOriginInfo: null,
  setRelationOriginInfo: noop,
  data: {},
  isLoaidng: false,
  setIsInfo: noop,
  isMatching: false,
  setIsMatching: noop,
  isInfo: false,
  objectId: 0,
});

export const BuildingMatchingContextProvider = ({ children, objectId }: PropsWithChildren & { objectId: number }) => {
  //TODO перетипизировать
  const [relationOriginInfo, setRelationOriginInfo] = useState<IExpenditureInHandlerProduction | null>(null);

  const [isInfo, setIsInfo] = useState(false);
  const productInfo = useBuildingMatchingProductInfo({ objectId, isInfo, relationOriginInfo });

  const [isMatching, setIsMatching] = useState(false);

  return (
    <BuildingMatchingContext.Provider
      value={{
        isInfo,
        isMatching,
        setIsMatching,
        relationOriginInfo,
        setRelationOriginInfo,
        setIsInfo,
        ...productInfo,
        objectId,
      }}
    >
      {children}
    </BuildingMatchingContext.Provider>
  );
};

export const useBuildingMatchingContext = () => useContext(BuildingMatchingContext);

type BuildingMatchingContextType = {
  relationOriginInfo: IExpenditureInHandlerProduction | null;
  setRelationOriginInfo: Dispatch<SetStateAction<IExpenditureInHandlerProduction | null>>;
  isLoaidng: boolean;
  data: any;
  isInfo: boolean;
  setIsInfo: Dispatch<SetStateAction<boolean>>;
  isMatching: boolean;
  setIsMatching: Dispatch<SetStateAction<boolean>>;
  objectId: number;
};
